import { Control, Controller } from 'react-hook-form';
import { InputSelect } from './InputSelect';
import { InputText } from './InputText';

type Props = {
  name: string;
  freeTextName: string;
  control: Control<any>;
};

export const InputGender = (props: Props) => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      render={({ field }) => {
        return (
          <>
            <InputSelect
              name="gender"
              label="Como você se identifica? (opcional)"
              control={props.control}
              options={genderOptions}
              className="w-full"
            />
            {field.value === 'Outros' && (
              <InputText
                name={props.freeTextName}
                control={props.control}
                label="Digite o gênero (Outros)"
              />
            )}
          </>
        );
      }}
    />
  );
};

export const genderOptions = [
  { value: ' ', label: ' ' },
  { value: 'Mulher Cis', label: 'Mulher Cis' },
  { value: 'Homem Cis', label: 'Homem Cis' },
  { value: 'Mulher Trans', label: 'Mulher Trans' },
  { value: 'Homem Trans', label: 'Homem Trans' },
  { value: 'Não Binário', label: 'Não Binário' },
  { value: 'Agênero', label: 'Agênero' },
  { value: 'Outros', label: 'Outros' },
];
